import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import Navbar from './components/Navbar.tsx'
import Hero from './components/Hero.tsx'
import About from './components/About.tsx'
import Portfolio from './components/Portfolio.tsx'
import Testimonials from './components/Testimonials.tsx'
import Contact from './components/Contact.tsx'
import BackToTop from './components/BackToTop.tsx'

function App() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-primary flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          className="flex items-center justify-center"
        >
          <img 
            src="/assets/logos/ad-logo-full.svg" 
            alt="AltDev Studios" 
            className="h-16 w-auto"
          />
        </motion.div>
      </div>
    )
  }

  return (
    <AnimatePresence>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Portfolio />
          <Testimonials />
          <Contact />
        </main>
        <BackToTop />
      </div>
    </AnimatePresence>
  )
}

export default App
